/**
 * Общие утилиты, которые должны грузиться в отложенном режиме
 *
 * Все такие утилиты являются асинхронными
 */

/**
 * Выполнить post запрос в окне браузера
 *
 * @see Api.ClientRequest.callInNewWindow
 * @see Api.ClientRequest.callInSelfWindow
 */
export const postInWindow = async (url: string, data: Record<string, any>, target: '_blank' | '_self'): Promise<void> => {
	const form = document.createElement('form');
	form.target = target;
	form.action = url;
	form.method = 'post';

	dataToForm(form, data);

	document.body.appendChild(form);
	form.submit();
	form.remove();
};

/**
 * Вставляет данные в HTML форму
 */
export const dataToForm = (elForm: HTMLFormElement, data: Record<string, any>): void => {
	const formData = formDataSerializer(data);

	for (const [key, value] of formData.entries()) {
		if (value instanceof File) {
			throw new Error('Files can not be manual set in `HTMLFormElement`');
		}

		const input = document.createElement('input');
		// input.type = 'hidden';
		input.name = key;
		input.value = String(value);
		elForm.appendChild(input);
	}
};

/**
 * Сериализация данных в объект FormData
 *
 * Для отправки файлов или генерации форм
 */
export const formDataSerializer = (data: Record<string, any>, formData: FormData = new FormData(), parentKey?: string): FormData => {
	for (const [key, value] of Object.entries(data)) {
		if (value === undefined || value === null) continue;

		const fieldKey = parentKey ? `${parentKey}[${key}]` : key;

		switch (true) {
			case value instanceof File:
				formData.append(fieldKey, value, value.name);

				break;
			case value instanceof FileList:
				for (let i = 0; i < value.length; i++) {
					const file = value.item(i);
					if (file) {
						formData.append(fieldKey + '[]', file, file.name);
					}
				}

				break;
			case value instanceof Blob:
				formData.append(fieldKey, value);

				break;
			case Array.isArray(value):
				// пустые массивы не передаются
				value.forEach((item, key) => {
					formDataSerializer({ [fieldKey + '[' + key + ']']: item }, formData);
				});

				break;
			case value instanceof Date:
				// для совместимости с JSON.stringify();
				formData.append(fieldKey, value.toISOString());

				break;
			case typeof value === 'object':
				formDataSerializer(value, formData, fieldKey);

				break;
			default:
				formData.append(fieldKey, String(value));
		}
	}

	return formData;
};

/**
 * Сериализация данных для вставки в виде параметров в url
 */
export const querySerializer = (data: Record<string, unknown>): string => {
	const searchParams = new URLSearchParams();

	const appendParam = (path: string, currentValue: unknown): void => {
		if (currentValue == null) return;

		if (Array.isArray(currentValue)) {
			for (const [key, value] of Object.entries(currentValue)) {
				appendParam(`${path}[${key}]`, value);
			}
			return;
		}

		if (typeof currentValue === 'object') {
			for (const [key, value] of Object.entries(currentValue as Record<string, unknown>)) {
				appendParam(`${path}[${key}]`, value);
			}
			return;
		}

		searchParams.append(path, String(currentValue));
	};

	for (const [key, value] of Object.entries(data)) {
		appendParam(key, value);
	}

	return searchParams.toString();
};
